import { Warning } from './../warning';

export class WarningBuilder {
  static fromJson(json) {
    return (json)
      ? new Warning(
        json.code,
        json.values
      )
      : null;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/warning.builder.ts